import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { pagesMenuPermissions } from 'app/pages/pages.menu.permissions';
import { Menu } from 'app/shared/models/control/menu';
import { AuthorizeService } from 'app/shared/services/control/authorization/authorization.service'; // leaf import - the app/shared/services/control barrel pulls in the whole control service set

@Injectable({ providedIn: 'root' })
export class MenuPermissionService {


    private readonly permissionByPath = new Map<string, string>();

    readonly changed: Observable<void>;

    constructor(private readonly authorize: AuthorizeService) {
        for (const entry of pagesMenuPermissions) {
            if (!this.permissionByPath.has(entry.path)) {
                this.permissionByPath.set(entry.path, entry.permissionName);
            }
        }
        this.changed = this.authorize.permissionsChanged;
    }

    permissionFor(path: string): string | undefined {
        return path ? this.permissionByPath.get(path) : undefined;
    }

    isPathAllowed(path: string): boolean {
        const required = this.permissionFor(path);
        return !required || this.authorize.hasPermission(required);
    }

    isVisible(item: Menu, ancestorPaths: string[] = []): boolean {
        return ancestorPaths.every(path => this.isPathAllowed(path))
            && this.isPathAllowed(item.path)
            && this.hasVisibleContent(item);
    }

    private hasVisibleContent(item: Menu): boolean {
        if (item.reportTitle || !item.children) {
            return true;
        }
        return item.children.some(child => this.isPathAllowed(child.path) && this.hasVisibleContent(child));
    }
}
